.error-screen-container {
  min-height: 15rem;
  width: 100%;
  margin: 6.4rem 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.error-screen-title {
  color: white;
  padding-bottom: 1.6rem;
  font-size: 1.8rem;
}

.error-screen-message {
  padding-bottom: 3.2rem;
  font-size: 1.6rem;
}
